const rectifiedStatus = [
    { label: 'Rectified', value: 'Rectified' },
    { label: 'Not Rectified', value: 'Not Rectified' }
];

export default rectifiedStatus;
